<script>
  import sanitizeClassName from '../../utils/sanitizeClassName';

  let {
    url = $bindable(),
    text = undefined,
    target = 'self',
    rel = $bindable(undefined),
    ariaLabel = undefined,
    key = undefined,
    className = $bindable(''),
    ref = $bindable(undefined),
    dataTestId = 'base-link',
    itemscope = undefined,
    itemtype = undefined,
    itemprop = undefined,
    content = undefined,
    tabindex = undefined,
    onFocus = () => {},
    onBlur = () => {},
    onClick = () => {},
    children
  } = $props();

  if (target === 'blank') {
      target = '_blank';
      rel = [...new Set([...(rel || '').split(' '), 'noreferrer', 'noopener'])].join(' ').trim();
    } else if (target === null) {
      target = undefined;
    } else {
      target = '_self';
    }
    
  // clean trailing slash to prevent 301s
  if (url && url.length > 1 && url[0] === '/') {
    let path = url;
    let query = '';

    if (url.indexOf('?') !== -1) {
      [path, query] = url.split('?');
    }

    if (path[path.length - 1] === '/') {
      path = path.slice(0, path.length - 1);
    }

    if (query && query.length) {
      url = `${path}?${query}`;
    } else {
      url = path;
    }
  }
  
  className = sanitizeClassName(className);
</script>

<a
  {key}
  data-testid={dataTestId}
  class={className}
  href={url}
  {target}
  {rel}
  {itemscope}
  {itemtype}
  {itemprop}
  {content}
  {tabindex}
  aria-label={ariaLabel}
  onclick={onClick}
  onfocus={onFocus}
  onblur={onBlur}
  bind:this={ref}
>
  {#if children}{@render children()}{:else}
    {#if text}{text}{/if}
  {/if}
</a>
